import React, { Component } from 'react';
import smoothscroll from 'smoothscroll';
import './styles.css';

import Navigation from '../navigation';
import Hero from '../hero';
import About from '../about';
import Map from '../map';
import Contact from '../contact';

class App extends Component {
  componentWillMount() {
    document.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.onScroll);
  }

  scrollTo = (id) => {
    const element = this.refs[id]

    smoothscroll(element.refs.dom);
  }

  onScroll = () => {

  }

  render() {
    return (
      <div className="App" ref="app">
        <Navigation scrollTo={this.scrollTo} />
        <Hero scrollTo={this.scrollTo} />
        <About ref="about" />
        <Map ref="map" />
        <Contact ref="contact" />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/app/index.js